import React from 'react';

import CodeMirrorJsonEditorField from '@wp-react/components/CodeMirror/CodeMirrorJsonEditorField';

import { useCurrentPreviewVariablesFieldName } from '../../hooks';

export default function TestDataInput() {
  const name = useCurrentPreviewVariablesFieldName();
  return (
    <CodeMirrorJsonEditorField
      key={name}
      name={name}
      sx={{
        border: '1px solid',
        borderColor: 'grey.300',
        mb: 3,
        '& .cm-editor': {
          minHeight: 400,
          height: 'calc(100vh - 480px)',
          resize: 'vertical',
          overflow: 'hidden',
        },
        '& .cm-focused': {
          outlineStyle: 'solid',
          outlineColor: '#9e9e9e',
        },
      }}
    />
  );
}
